export default __webpack_public_path__ + "static/media/EST.b6cbf332.png";